import { React, useEffect, useState } from "react";
import {
  RightLayoutContainer,
  DownArrowDraw,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DropDownSearchDraw,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Select,
  Input,
  PageHeader,
  Upload,
  message,
  Tooltip,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import {
  getCompanyDetails,
  postCompany,
  putCompany,
} from "../../../Services/companyServices";
import { Country, State } from "country-state-city";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { uploadImage } from "../../../Services/profileServices";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import { getImageURL } from "../../../Services/deckleMatchServices";
import { newUploadOrders } from "../../../Services/uploadServices";

const { Dragger } = Upload;
const { Option } = Select;

const CompanyInformationData = (props) => {
  const [cities, setCities] = useState([]);
  const [form] = Form.useForm();
  const [editMode, setEditMode] = useState(false);
  const [companyDetails, setCompanyDetails] = useState({});
  // Toasters
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [uploadLogo, setUploadLogo] = useState({
  });
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [uploadedFile, setUploadedFile] = useState(null);
  const [primaryContactError, setPrimaryContactError] = useState("");
  const [cancelModal, setCancelModal] = useState(false);
  const [isCountryDropdownOpen, setCountryDropdown] = useState(false);
  const [isStateDropdownOpen, setStateDropdown] = useState(false);

  const draggerProps = {
    name: "file",
    multiple: false,
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
        //let imageTag = document.getElementById("imageId")
        //imageTag.src = URL.createObjectURL(info.file.originFileObj)
        //imageTag.srcObject = info.file.originFileObj;
        setUploadedFile(info.file.originFileObj);
      }
      if (status == "removed") {
        setUploadedFile(null);
        setCompanyDetails({ ...companyDetails, logo: "" });
      }
      if (status === "done") {
        //message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        //message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const handleProvinceChange = (value) => {
    setCities(State.getStatesOfCountry(value));
    form.setFieldsValue({ state: State.getStatesOfCountry(value)[0]?.name });
  };

  const handleSave = () => {
    validatePrimaryContact(form.getFieldValue("primary_contact_no"));
    if (!primaryContactError) {
      form.submit();
    }
  };

  const showCancelModal = () => {
    setCancelModal(true);
  };

  const closeCancelModal = () => {
    setCancelModal(false);
  };

  const confirmCancelModal = () => {
    form.resetFields();
    // console.log('Value inside log', form.getFieldValue('logo'));
    localStorage.removeItem("logo");
    setUploadLogo({
      selectedFile: null,
    });
    setCancelModal(false);
    setEditMode(false)
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const getFlag = (short) => {
    const data = require(`world_countries_lists/data/flags/24x24/${short.toLowerCase()}.png`);
    // for dummy
    if (typeof data === "string") {
      return data;
    }
    // for CRA
    return data.default;
  };
  const getBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const validatePrimaryContact = (e) => {
    if (!e?.phone) setPrimaryContactError("This field is required");
    else if (!/^\d+$/.test(e.phone))
      setPrimaryContactError("Only numerical values are accepted");
    else setPrimaryContactError("");
  };

  const addCompany = async (values, action) => {
    console.log("values logo:", values.logo);
    if (uploadedFile) {
       const url = await getImageURL({
          bucket_key: uploadedFile.name,
          operation: "upload",
        })
        newUploadOrders(url, uploadedFile)
        .then((resp) => {})
        .catch((err) => {});
    }
    values.logo &&
      values.logo.file &&
      values.logo.file.status !== "removed" &&
      getBase64(values.logo.file.originFileObj)
        .then((base64) => {
          localStorage["logo"] = base64;
          setUploadLogo({
            selectedFile: base64,
          });
          // console.log("file stored", base64);
        })
        .catch((error) => {
          console.log("Error in saving the logo:", error);
        });
    // console.log('Action inside:',action);
    const body = {
      address_line_1: values.contactaddress_firstline,
      address_line_2: values.contactaddress_secondline,
      state: values.state,
      city: values.city,
      pincode: values.zip_code,
      country:
        action === "add"
          ? Country.getCountryByCode(values.country).name
          : values.country,
      contact_person: values.contact_person,
      primary_phone_number: `${values.primary_contact_no.short}-${values.primary_contact_no.phone}`,
      secondary_phone_number: `${values.alternate_contact_no.short}-${values.alternate_contact_no.phone}`,
      primary_email: values.primary_email,
      secondary_email: values.alternate_email,
      business_name: values.business_name,
      owner_name: values.business_owner,
      gst_number: values.gst_no,
      pan_number: values.pan_no,
      logo: uploadedFile
        ? uploadedFile.name
        : companyDetails.logo
        ? companyDetails.logo
        : "",
      website: values.web_address,
      remarks: "Adding new company",
      phoneCodes: values.primary_contact_no,
    };
    // console.log("body inside request:", body);
    action === "add"
      ? postCompany(body)
          .then((response) => {
            setEditMode(false);
            console.log("Response in Adding a company:", response);
            setActionToaster({
              error: response.error,
              msg: "Company is successfully added",
            });
            showToaster();
          })
          .catch((error) => {
            console.log("Error in adding company:", error.response);
            // setActionToaster({
            //   error: error.response.error,
            //   msg: "Error in adding company",
            // });

            if(error?.response?.status == 500){
              props.toasterAction({
                error: true,
                msg: "Something went wrong. Please try again",
              });
            } else{
              props.toasterAction({
                error: true,
                msg: error?.response?.data?.msg,
              });
            }
            showToaster();
          })
      : putCompany(body)
          .then((response) => {
            setEditMode(false);
            console.log("Response in Editing company:", response);
            setActionToaster({
              error: response.error,
              msg: "Company details is successfully saved",
            });
            showToaster();
          })
          .catch((error) => {
            console.log("Error in editing company details:", error.response);
            // setActionToaster({
            //   error: error.response.error,
            //   msg: "Error in saving company details",
            // });
            if(error?.response?.status == 500){
              props.toasterAction({
                error: true,
                msg: "Something went wrong. Please try again",
              });
            } else{
              props.toasterAction({
                error: true,
                msg: error?.response?.data?.msg,
              });
            }
            showToaster();
          });
  };

  const OnCountryToggleSelect =()=>{
    setCountryDropdown((prevState) => !prevState
  )
  };

  const OnStateToggleSelect =()=>{
    setStateDropdown((prevState) => !prevState
  )
  };

  const onFinish = (events) => {
    // console.log('events from the form:',events);
    addCompany(events, Object.keys(companyDetails).length ? "edit" : "add");
  };

  const onFinishFailed = (error) => {
    console.log("Error in submitting the form:", error);
  };

  useEffect(() => {
  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanyDetails();
      let companyData = response.data;

      if (companyData.logo) {
        try {
          const url = await getImageURL({
            bucket_key: companyData.logo,
            operation: "download",
          });
          companyData = { ...companyData, logo: url };
        } catch (error) {
          console.error("Error fetching logo:", error);
        }
      }

      setCompanyDetails(companyData);
    } catch (error) {
      console.error("Error in getting company details:", error.response?.data || error.message);
    }
  };

  fetchCompanyDetails();

  // optional cleanup if needed:
  // return () => setCompanyDetails({});
}, []);

  useEffect(() => {
    // console.log("CompanyDetails:", companyDetails);
    Object.keys(companyDetails).length &&
      form.setFieldsValue({
        contactaddress_firstline: companyDetails.address_line_1,
        contactaddress_secondline: companyDetails.address_line_2,
        state: companyDetails.state,
        city: companyDetails.city,
        zip_code: companyDetails.pincode,
        country: companyDetails.country,
        contact_person: companyDetails.contact_person,
        primary_contact_no: {
          short: companyDetails.primary_phone_number?.substring(
            0,
            companyDetails.primary_phone_number.indexOf("-")
          ),
          phone: companyDetails.primary_phone_number?.substring(
            companyDetails.primary_phone_number.indexOf("-") + 1
          ),
        },
        alternate_contact_no: {
          short: companyDetails.secondary_phone_number?.substring(
            0,
            companyDetails.secondary_phone_number.indexOf("-")
          ),
          phone: companyDetails.secondary_phone_number?.substring(
            companyDetails.secondary_phone_number.indexOf("-") + 1
          ),
        },
        primary_email: companyDetails.primary_email,
        alternate_email: companyDetails.secondary_email,
        business_name: companyDetails.business_name,
        business_owner: companyDetails.owner_name,
        gst_no: companyDetails.gst_number,
        pan_no: companyDetails.pan_number,
        logo: companyDetails.logo,
        web_address: companyDetails.website,
        // remarks: "Adding new company"
      });
  }, [companyDetails]);

  useEffect(()=>{
    async function fetchLogo() {
      const response = localStorage.getItem("logo") && await getImageURL({
        bucket_key: localStorage.getItem("logo"),
        operation: "download",
      })
      setUploadLogo({
        selectedFile: response || null,
      });
    }
    fetchLogo()
  },[])

  return (
    <RightLayoutContainer>
      <PageTitleComp>
        <PageHeader
          ghost={false}
          title="Edit Company Profile"
          extra={
            editMode
              ? [
                  <Button
                    key="3"
                    className="textTypeBtn"
                    onClick={showCancelModal}
                  >
                    Cancel changes
                  </Button>,
                  <Button key="2" className="themeBtn" onClick={handleSave}>
                    <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                    Save
                  </Button>,
                ]
              : userDetails.roles.company_profile.edit && [
                  <Tooltip title="Edit Company Profile">
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={() => setEditMode(true)}
                    >
                      <Iconmoon icon="edit" size={14} color="#ffffff" />
                      Edit
                    </Button>
                  </Tooltip>,
                ]
          }
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>Enter general details of your company</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Business Name</label>
                        <p>Your business will be identified using this name</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="business_name"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 100,
                              message: "Maximum 100 characters are allowed",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.business_name}
                        >
                          <Input
                            placeholder="Enter the business name of your company"
                            disabled={!editMode}
                            // defaultValue="Alpha Mission Inc,"
                            style={{ textTransform: "capitalize" }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Name of Company Head </label>
                        <p>This person owns or heads the company</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="business_owner"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 50,
                              message: "Maximum 50 characters are allowed",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.owner_name}
                        >
                          <Input
                            placeholder="Enter the name of the owner"
                            style={{ textTransform: "capitalize" }}
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          GST Number<span> (Optional)</span>
                        </label>
                        <p>GST identification number of your company (GSTIN)</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="gst_no"
                          rules={[
                            {
                              pattern: /^[0-9a-zA-Z]{15}$/,
                              message: "GST Number is invalid",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.gst_number}
                        >
                          <Input
                            placeholder="Enter the GST number"
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          PAN Number<span> (Optional)</span>
                        </label>
                        <p>10 Digit PAN number of the company</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="pan_no"
                          rules={[
                            {
                              pattern: /^[0-9a-zA-Z]{10}$/,
                              message: "PAN Number is invalid",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.pan_number}
                        >
                          <Input
                            placeholder="Enter the PAN number"
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Contact Details</h2>
                    <p>Enter contact details of your company</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Contact Person<span> (Optional)</span>
                        </label>
                        <p>
                          Customers and Haber can contact this person for
                          support
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="contact_person"
                          rules={[
                            {
                              pattern: /^[0-9a-zA-Z ]+$/,
                              message: "Invalid",
                            },
                            {
                              max: 50,
                              message: "Maximum 50 characters are allowed",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.contact_person}
                        >
                          <Input
                            placeholder="Enter the name of the contact person"
                            style={{ textTransform: "capitalize" }}
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Primary Contact Number</label>
                        <p>Enter the primary contact of your company</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <ConfigProvider
                          locale={en}
                          form={{ requiredMark: false }}
                          areaMapper={(area) => {
                            return {
                              ...area,
                              emoji: (
                                <img
                                  alt="flag"
                                  style={{
                                    width: 18,
                                    height: 18,
                                    verticalAlign: "sub",
                                  }}
                                  src={getFlag(area.short)}
                                />
                              ),
                            };
                          }}
                        >
                          <Form.Item
                            name="primary_contact_no"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className=""
                            initialValue={{
                              short:
                                companyDetails.primary_phone_number?.substring(
                                  0,
                                  companyDetails.primary_phone_number.indexOf(
                                    "-"
                                  )
                                ),
                              phone:
                                companyDetails.primary_phone_number?.substring(
                                  companyDetails.primary_phone_number.indexOf(
                                    "-"
                                  ) + 1 || ""
                                ),
                            }}
                          >
                            <CountryPhoneInput
                              className="intlPhone"
                              placeholder="Enter the contact number"
                              disabled={!editMode}
                              onChange={validatePrimaryContact}
                            />
                          </Form.Item>
                          {primaryContactError ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              {primaryContactError}
                            </span>
                          ) : null}
                        </ConfigProvider>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Alternate Contact Number<span> (Optional)</span>
                        </label>
                        <p>Enter the alternate contact of your company</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <ConfigProvider
                          locale={en}
                          areaMapper={(area) => {
                            return {
                              ...area,
                              emoji: (
                                <img
                                  alt="flag"
                                  style={{
                                    width: 18,
                                    height: 18,
                                    verticalAlign: "sub",
                                  }}
                                  src={getFlag(area.short)}
                                />
                              ),
                            };
                          }}
                        >
                          <Form.Item
                            name="alternate_contact_no"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className=""
                            initialValue={{
                              short:
                                companyDetails.secondary_phone_number?.substring(
                                  0,
                                  companyDetails.secondary_phone_number.indexOf(
                                    "-"
                                  )
                                ),
                              phone:
                                companyDetails.secondary_phone_number?.substring(
                                  companyDetails.secondary_phone_number.indexOf(
                                    "-"
                                  ) + 1
                                ),
                            }}
                          >
                            <CountryPhoneInput
                              className="intlPhone"
                              placeholder="Enter the alternate contact number"
                              // defaultValue={{ short: "IN" }}
                              disabled={!editMode}
                              initialValue={
                                companyDetails?.secondary_phone_number
                              }
                            />
                          </Form.Item>
                        </ConfigProvider>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Primary Email ID</label>
                        <p>Enter the primary email ID of your company</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="primary_email"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              type: "email",
                              message: "Email Format is invalid",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.primary_email}
                        >
                          <Input
                            placeholder="Enter the email id"
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Alternate Email ID<span> (Optional)</span>
                        </label>
                        <p>Enter the alternate email ID of your company</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="alternate_email"
                          rules={[
                            {
                              type: "email",
                              message: "Email Format is invalid",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.secondary_email}
                        >
                          <Input
                            placeholder="Enter the alternate email id"
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Office Address</h2>
                    <p>The complete address of the company</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Complete Office Address</label>
                        <p>The complete postal address of the company</p>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <Form.Item
                          name="contactaddress_firstline"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 50,
                              message: "Maximum 50 characters are allowed",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.address_line_1}
                        >
                          <Input
                            placeholder="First Line of address"
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                      <div className="boxFormType">
                        <Form.Item
                          name="contactaddress_secondline"
                          rules={[
                            {
                              max: 50,
                              message: "Maximum 50 characters are allowed",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.address_line_2}
                        >
                          <Input
                            placeholder="Second Line of address"
                            disabled={!editMode}
                          />
                        </Form.Item>
                      </div>
                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <Form.Item
                            name="country"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className=""
                            initialValue={companyDetails?.country}
                          >
                            <Select
                              suffixIcon={ isCountryDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                              onBlur = {OnCountryToggleSelect}
                              onFocus = {OnCountryToggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) => 
                                option.children.toLowerCase().
                                includes(input.toLowerCase())}
                              placeholder="Country"
                              disabled={!editMode}
                              onChange={handleProvinceChange}
                            >
                              {Country.getAllCountries().map((province) => (
                                <Option key={province.isoCode}>
                                  {province.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                        <div className="boxFormType">
                          <Form.Item
                            name="state"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            initialValue={companyDetails?.state}
                          >
                            <Select
                              suffixIcon={ isStateDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                              onBlur = {OnStateToggleSelect}
                              onFocus = {OnStateToggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) => 
                                option.children.toLowerCase().
                                includes(input.toLowerCase())}
                              placeholder="State"
                              disabled={!editMode}
                            >
                              {cities.map((city) => (
                                <Option key={city.name}>{city.name}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name="city"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                max: 50,
                                message: "Maximum 50 characters are allowed",
                              },
                            ]}
                            className=""
                            initialValue={companyDetails?.city}
                          >
                            <Input
                              placeholder="City"
                              disabled={!editMode}
                              style={{ textTransform: "capitalize" }}
                            />
                          </Form.Item>
                        </div>
                        <div className="boxFormType">
                          <Form.Item
                            name="zip_code"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                len: 6,
                                message: "ZIP code is invalid",
                              },
                            ]}
                            className=""
                            initialValue={companyDetails?.pincode}
                          >
                            <Input
                              placeholder="ZIP code"
                              // type="number"
                              // value={value.number || number}
                              disabled={!editMode}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All Other information related to your company</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Website of business <span>(Optional)</span>
                        </label>
                        <p>
                          The company website will be used web pages and reports
                        </p>
                      </div>
                    </Col>
                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <Form.Item
                          name="web_address"
                          rules={[
                            {
                              max: 100,
                              message: "Maximum 100 characters allowed",
                            },
                            {
                              type: "url",
                              message: "Invalid website",
                            },
                          ]}
                          className=""
                          initialValue={companyDetails?.website}
                        >
                          <Input
                            placeholder="Website"
                            disabled={!editMode}
                            style={{ textTransform: "lowercase" }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Logo <span>(Optional)</span>
                        </label>
                        <p>
                          The logo will be displayed in web pages and reports
                        </p>
                      </div>
                    </Col>
                    <Col span={12} className="blockBreak">
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          name="logo"
                          className=""
                          initialValue={companyDetails?.logo}
                          value={companyDetails?.logo}
                          rules={[
                            {
                              validator(_, value) {
                                const file = value?.file;
                                // console.log('file in validaiton:',file);
                                if (
                                  file === null ||
                                  file === undefined ||
                                  file.size / 1024 < 500 ||
                                  file.size === undefined
                                ) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    "The file size limit is 500KB"
                                  );
                                }
                              },
                            },
                          ]}
                        >
                          {false && (
                            <div>
                              <img
                                id="imageId"
                                style={
                                  !uploadedFile?.name
                                    ? { visibility: "hidden" }
                                    : {}
                                }
                                src=""
                                alt="company logo"
                              />
                            </div>
                          )}

                          {editMode && (
                            <Dragger
                              // {...draggerProps}
                              // listType="picture"
                              // accept="image/png, image/jpeg, image/jpg, image/svg+xml, image/gif"
                              // maxCount={1}
                              // disabled={!editMode}
                              // // condition checking before uploading
                              // beforeUpload={(file) => {
                              //   console.log("beforeUpload file:", file);
                              //   const isLt500K = file.size / 1024 < 2048;
                              //   if (!isLt500K) {
                              //     setActionToaster({
                              //       error: true,
                              //       msg: "File size should be less than 2mb",
                              //     });
                              //     showToaster();
                              //   }
                              //   return isLt500K;
                              // }}
                              {...draggerProps}
                                listType="picture"
                                accept="image/png, image/jpeg, image/jpg, image/gif" // SVG removed
                                maxCount={1}
                                disabled={!editMode}
                                beforeUpload={(file) => {
                                  console.log("beforeUpload file:", file);

                                  // ✅ File size check (less than 2 MB)
                                  const isLt2MB = file.size / 1024 / 1024 < 2;
                                  if (!isLt2MB) {
                                    setActionToaster({
                                      error: true,
                                      msg: "File size should be less than 2 MB",
                                    });
                                    showToaster();
                                    return Upload.LIST_IGNORE; // Prevent upload
                                  }

                                  // ✅ Block SVG uploads
                                  const fileType = file.type;
                                  if (fileType === "image/svg+xml" || file.name.toLowerCase().endsWith(".svg")) {
                                    setActionToaster({
                                      error: true,
                                      msg: "SVG files are not allowed. Please upload PNG, JPG, or GIF.",
                                    });
                                    showToaster();
                                    return Upload.LIST_IGNORE; // Prevent upload
                                  }

                                  // ✅ Allow upload
                                  return true;
                                }}
                            >
                              {/* Uploaded image showing */}
                              {uploadLogo.selectedFile ? (
                                !editMode && (
                                  <Row>
                                    <Col span={14}>
                                      <img
                                        src={uploadLogo.selectedFile}
                                        alt="logo"
                                        style={{ width: "100%" }}
                                      />
                                    </Col>
                                    <Col span={10}></Col>
                                  </Row>
                                )
                              ) : (
                                <div>
                                  {/* {console.log(
                                    "selectedFile:",
                                    uploadLogo.selectedFile
                                  )} */}
                                  <p className="ant-upload-drag-icon">
                                    <Iconmoon
                                      icon="upload-image"
                                      size={18}
                                      color="#A19F9D"
                                    />{" "}
                                  </p>
                                  <p className="ant-upload-text">
                                    <span>Click to add</span> or drag and drop
                                  </p>
                                  <p className="ant-upload-hint">
                                    PNG, JPG or GIF (max. 800 x 400 px)
                                  </p>
                                </div>
                              )}
                              {/* {uploadLogo.selectedFile && !editMode?
                      <Row>
                        <Col span={14}>
                          <img src={uploadLogo.selectedFile} alt='logo'
                          style={{width:'100%'}}/>
                        </Col>
                        
                      </Row>
                          :
                          !isUploaded && !uploadLogo.selectedFile &&                      
                            <div>
                              <p className="ant-upload-drag-icon">
                                <Iconmoon
                                  icon="upload-image"
                                  size={18}
                                  color="#A19F9D"
                                />{" "}
                              </p>
                              <p className="ant-upload-text">
                                <span>Click to add</span> or drag and drop
                              </p>
                              <p className="ant-upload-hint">
                                SVG, PNG, JPG or GIF (max. 800 x 400 px)
                              </p>
                            </div>
                        } */}
                            </Dragger>
                          )}
                          {!uploadedFile && companyDetails.logo && (
                            <div className="company-logo-display">
                              <img
                                src={`${companyDetails.logo}`}
                                alt="company logo"
                              />
                            </div>
                          )}
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {/* Toasters */}
      {visibleToaster && (
        <AlertContainer
          setClose={setVisibleToaster}
          color={actionToaster.error ? "red toaster" : "green toaster"}
          icon={actionToaster.error ? alertRed : alertGreen}
          msg={actionToaster.msg}
          closeIcon={true}
        />
      )}
      <ConfirmationModal
        visible={cancelModal}
        icon={warning}
        cancelAction={closeCancelModal}
        confirmAction={confirmCancelModal}
      >
        <span>Are you sure ?</span>
        <p>
          No changes will be saved in the details. Are you sure you want to
          cancel changes ?
        </p>
      </ConfirmationModal>
    </RightLayoutContainer>
  );
};

export default CompanyInformationData;
